const calendly = {
  ".calendly-popup,.calendly-overlay": {
    top: "0!important",
    left: "0!important",
    width: "100%!important",
    height: "100%!important",
    maxWidth: "unset!important",
    maxHeight: "unset!important",
    transform: "unset!important",
  },
  ".calendly-close-overlay": {
    display: "none!important",
  },
  ".calendly-popup-content": {
    bgColor: "rgba(52, 64, 84, 0.7)!important",
    backdropFilter: "blur(8px)!important",
  },
  ".calendly-popup-close": {
    right: "32px!important",
    bgColor: "#FCD77C!important",
    padding: "18px!important",
    backgroundImage: "url(/icons/close.webp)!important",
    backgroundSize: "24px 24px!important",
    backgroundPosition: "center!important",
    backgroundRepeat: "no-repeat!important",
    rounded: "full!important",
    shadow: "md!important",
  },
};

export default calendly;
